module.exports = __webpack_public_path__ + "static/media/dots.a770e120.svg";